import Alert from '@/components/Alert';
import { useIsPortfolioAccount } from '@/hooks/accounts/useIsPortfolioAccount';

const PortfolioAlert = ({
  applicableToAllAccounts = true,
}: {
  applicableToAllAccounts?: boolean;
}) => {
  const { isPortfolioAccount } = useIsPortfolioAccount();

  if (!isPortfolioAccount) return null;

  return (
    <Alert severity="info">
      <strong>Please note: </strong>
      changes will apply to{' '}
      {applicableToAllAccounts ? 'all accounts' : 'this account only'}.
    </Alert>
  );
};

export default PortfolioAlert;
